import { OrderResource } from "../resources/order-resource";
import { OrderAdapter } from "../adapters/order-adapter";
import {
  ClientOrder,
  ClientOrderOptions,
  ClientCreateOrder,
  ClientCreateOrderResponse,
} from "../types/order";

export const OrderRepository = {
  async fetchOrderOptions(): Promise<ClientOrderOptions> {
    const options = await OrderResource.getOptions();
    return OrderAdapter.toClientOptions(options);
  },

  async createOrder(
    order: ClientCreateOrder,
  ): Promise<ClientCreateOrderResponse> {
    const apiCreateOrder = OrderAdapter.toApiPostOrder(order);
    const response = await OrderResource.createOrder(apiCreateOrder);
    return { orderId: response.order_id, paymentUrl: response.payment_url, message: response.message };
  },

  async confirmOrder(query: string): Promise<void> {
    await OrderResource.confirmOrder(query);
  },
};
